let yt_check_jq = setInterval(() => {
    if(typeof jQuery != 'undefined') {
        clearInterval(yt_check_jq);

        jQuery(document).ready(function() {
            jQuery('body').on('change', '#yt_double_power', function() {
                var $quantityInput = jQuery('quantity-input input[name="quantity"]');
                var $priceElement = jQuery('#yt-double-price');
                var $totalPrice = jQuery('#total-price');
                var originalPrice = parseFloat($priceElement.data('original-price'));
                if (!originalPrice) {
                    originalPrice = parseFloat($priceElement.text().replace(/[^0-9.]/g, ''));
                    $priceElement.data('original-price', originalPrice);
                }

                if (jQuery(this).is(':checked')) {
                    jQuery('input[name="properties[_Is Dual Lens]"]')?.val(1);
                    jQuery('#right-eye-box').css('display', 'flex');
                    $quantityInput.attr('min', 2);
                    $totalPrice.css('display', 'block');

                    var currentVal = parseInt($quantityInput.val()) || 0;
                    $quantityInput.val(currentVal * 2);

                    $priceElement.text((originalPrice * 2).toFixed(2));
                } else {
                    jQuery('input[name="properties[_Is Dual Lens]"]')?.val(0);
                    jQuery('#right-eye-box').css('display', 'none');
                    $quantityInput.attr('min', 1);
                    $totalPrice.css('display', 'none');
                    var currentVal = parseInt($quantityInput.val()) || 0;
                    $quantityInput.val(currentVal / 2);

                    $priceElement.text(originalPrice.toFixed(2));

                    /* Empty right eye values */
                    jQuery('select[name="properties[Right Eye Sphere]"]')?.val('');
                    jQuery('select[name="properties[Right Eye Cylinder]"]')?.val('');
                    jQuery('select[name="properties[Right Eye Axis]"]')?.val('');
                }
            });

            /* Cart button modification */
            jQuery(document).on('click', '.yt-addtocart-cta', function(e) {
                e.preventDefault();
                let error_arr = [];
                let dual_lens = jQuery('input[name="yt_double_power"]')?.is(':checked');

                let sphere_left    = jQuery('select[name="properties[Left Eye Sphere]"]');
                let sphere_right   = jQuery('select[name="properties[Right Eye Sphere]"]');
                let cylinder_left  = jQuery('select[name="properties[Left Eye Cylinder]"]');
                let cylinder_right = jQuery('select[name="properties[Right Eye Cylinder]"]');
                let axis_left      = jQuery('select[name="properties[Left Eye Axis]"]');
                let axis_right     = jQuery('select[name="properties[Right Eye Axis]"]');

                // Clear previous errors
                [sphere_left, sphere_right, cylinder_left, cylinder_right, axis_left, axis_right].forEach(function($el) {
                    $el.parent().removeClass('yt-field-error');
                });

                // Only include fields that actually exist in the DOM
                let left_fields  = [sphere_left, cylinder_left, axis_left].filter($el => $el.length > 0);
                let right_fields = [sphere_right, cylinder_right, axis_right].filter($el => $el.length > 0);

                function validateFields(fields) {
                    if (fields.length === 0) return; // No fields, skip

                    if (fields.length === 1) {
                        // Single field — must be filled
                        let $field = fields[0];
                        let val = ($field.val() || '').trim();
                        if (!val) {
                            error_arr.push('error');
                            $field.parent().addClass('yt-field-error');
                        }
                    } else {
                        // Multiple fields — at least 1 must be filled
                        let anyFilled = fields.some($el => ($el.val() || '').trim() !== '');
                        if (!anyFilled) {
                            fields.forEach($el => {
                                error_arr.push('error');
                                $el.parent().addClass('yt-field-error');
                            });
                        }
                    }
                }

                validateFields(left_fields);
                if (dual_lens) validateFields(right_fields);

                if (error_arr.length === 0) {
                    jQuery(this).parent().find('button[type="submit"]').click();
                }
            });

            /* Remove error class on click */
            jQuery(document).on('click', 'select[name*="properties"]', function(){
                if(jQuery(this).parent().hasClass('yt-field-error')){
                    /* jQuery(this).parent().removeClass('yt-field-error'); */
                    console.log(jQuery(this).closest('.eye-box'));
                    jQuery(this).closest('.eye-box').find('.yt-field-error').removeClass('yt-field-error');
                }
            });
        });

        (function() {
            var price = parseFloat(jQuery('#price-value').data('price')) || 0;
            function updateTotal() {
                var qty = parseInt(jQuery('quantity-input input[name="quantity"]').val()) || 1; 
                if (jQuery('#yt_double_power').is(':checked')) {
                    qty += 0;
                }
                jQuery('#price-qty').text(qty);
                var total = price * qty;
                jQuery('#price-total').text(total.toFixed(2));
            }
            jQuery(document).on('input change', 'quantity-input input[name="quantity"], #yt_double_power', updateTotal);
            updateTotal();
        })();
    }
});